export default __webpack_public_path__ + "e82270256715b3b0ac394b1148eb79d4.png";